import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Navbar from "./components/Navbar";
import HeroBanner from "./components/HeroBanner";
import Features from "./components/Features";
// import Pricing from './components/Pricing';
import DownloadAppSection from "./components/DownloadAppSection";
import Contact from "./components/Contact";
import InterestedClients from "./components/InterestedClients";
import FaqGrid from "./components/Faq";
import UserGuidePage from "./components/UserGuidePage";
import Testimonials from "./components/Testimonials";
import PricingCalculator from "./components/PricingCalculator";
import DocsLayout from "./components/docs/DocsLayout";
import DocsLanding from "./components/docs/DocsLanding";
import DocPage from "./components/docs/DocPage";
import LanguageSelector from "./components/LanguageSelector";
import i18n from "./i18n";

function HomePage() {
  return (
    <div className="">
      <HeroBanner />
      <Features />
      <DownloadAppSection />
      <Testimonials />
      <InterestedClients />
      {/* <Pricing /> */}
      <UserGuidePage />
      <FaqGrid />
      <Contact />
    </div>
  );
}

function App() {
  return (
    <Router>
      <div className="">
        <LanguageSelector />
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/pricing-calculator" element={<PricingCalculator />} />
          {/* Redirect /docs to /:lang/docs */}
          <Route
            path="/docs/*"
            element={
              <Navigate to={`/${i18n.language.split("-")[0]}/docs`} replace />
            }
          />
          <Route
            path=":lang/docs"
            element={
              <DocsLayout>
                <DocsLanding />
              </DocsLayout>
            }
          />
          <Route
            path=":lang/docs/*"
            element={
              <DocsLayout>
                <DocPage />
              </DocsLayout>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
